import Tree from './Tree';
export default Tree;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ../~/_antd@3.23.4@antd/es/tree/index.js
// module id = 854
// module chunks = 0